import { Message } from '@showclix-shared/CheckoutProcess/components/Message';

export default Message;
